import * as orderActionTypes from "ActionTypes/orderActionTypes";
import orderInitialState from "InitialStates/orderInitialState";
const reducers = {
  setOrderSuccessInfo: (state, action) => {
    return {
      ...state,
      ...action.order
    };
  },
  setOrderErrorInfo: (state, action) => {
    return {
      ...state,
      ...action.error
    };
  },
  closeOrderPopup: (state, action) => {
    return {
      ...state,
      openPopup:false
    };
  },
  orderTermsInfo: (state, action) => {
    return {
      ...state,
      orderTerms: action.orderTerms
    };
  },
  arOrderTermsInfo: (state, action) => {
    return {
      ...state,
      arOrderTerms: action.arOrderTerms
    };
  },
  setIsOrderTermsLoading: (state, action) => {
    return {
      ...state,
      isLoading: action.isLoading
    };
  }
};

const orderReducer = (state = orderInitialState, action) => {
  switch (action.type) {
    case orderActionTypes.ORDER_SUCCESS:
      return reducers.setOrderSuccessInfo(state, action);
    case orderActionTypes.ORDER_FAILED:
      return reducers.setOrderErrorInfo(state, action);
    case orderActionTypes.CLOSE_ORDER_POPUP:
      return reducers.closeOrderPopup(state, action);
    case orderActionTypes.ORDER_TERMS_INFO:
      return reducers.orderTermsInfo(state, action);
    case orderActionTypes.ARORDER_TERMS_INFO:
      return reducers.arOrderTermsInfo(state, action);
    case orderActionTypes.SET_IS_ORDERTERMS_LOADING:
      return reducers.setIsOrderTermsLoading(state, action);
    default:
      return state;
  }
};

export default orderReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/orderReducer.js